<template>
    <!-- {{ mainques }} -->
    <!-- 1041 1035 1040 1042-->

    <div class="accordion-item mt-0" v-if="qType == 1038">
        <h4 class="accordion-header" id="headingOne">
            <button class="accordion-button fw-bolder align-items-sm-start" type="button" data-bs-toggle="collapse"
                aria-expanded="true" aria-controls="Q1" :class="{ collapsed: this.question.show == false }"
                @click=onTabPress(this.question.qid)>
                <span class="me-2">Q.{{ this.index + 1 }}</span>
                <div style="display: flex;flex-wrap: wrap; align-items: flex-start;">
                    <span v-html="this.question?.question"></span>
                    <span v-if="question.responses == null && qType != 1005" class="Unanswered_text">Unanswered</span>

                </div>
            </button>
        </h4>
        <div :class="{ show: this.question.show }" class="accordion-collapse collapse" aria-labelledby="headingOne"
            data-bs-parent="#accordionExample">
            <div class="accordion-body p-0">
                <div class="row">
                    <div class="col-md-12">
                        <div class="Report_basic_info_area active-report-repsponses my-4"
                            v-for="resp in this.question?.responses" :key="resp">
                            <p class="my-3 border-top p-3">
                                <b>Candidate Input:</b> <br>
                                {{ resp.candidateInputs }}
                            </p>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>


    <div class="accordion-item mt-0" v-if="qType == 1003">
        <!-- <h2>new code</h2> -->
        <h4 class="accordion-header" id="headingOne">
            <button class="accordion-button fw-bolder align-items-sm-start " type="button" data-bs-toggle="collapse"
                aria-expanded="true" aria-controls="Q1" :class="{ collapsed: this.question.show == false }"
                @click=onTabPress(question.qid)>
                <span class="me-2">Q.{{ this.index + 1 }}</span>
                <div style="display: flex;flex-wrap: wrap; align-items: flex-start;">
                    <span v-html="this.question?.question"></span>
                    <span v-if="question.responses == null && qType != 1005" class="Unanswered_text">Unanswered</span>
                </div>
            </button>
        </h4>
        <div :class="{ show: this.question.show }" class="accordion-collapse collapse" aria-labelledby="headingOne"
            data-bs-parent="#accordionExample">
            <div class="accordion-body p-0">
                <div class="ms-3" v-if="this.question?.imageUrl">
                    <img :src="question?.imageUrl" alt="no image" style="width: 100%; max-width: 720px;">
                </div>
                <!-- <hr> -->
                <div class="Report_Responses_Answer_option_list_area">

                    <!-- <div v-for="data in this.question?.questionOptions" :key="data"
                        class="Report_Responses_Answer_option_item" :class="[
                                data.isPsychometryOption
                                    ? data.isChecked
                                        ? 'Report_Responses_right_option_section'
                                        : ''
                                    : data.optionWeightage > 0.0
                                        ? 'Report_Responses_right_option_section'
                                        : data.isChecked
                                            ? 'Report_Responses_wrong_option_section'
                                            : '',
                            ]">
                        {{ data.optionName }}
                    </div> -->

                    <div class="my-3 border-top py-4 mx-4 question-card">
                        <b class="question-heading">Candidate Inputs:</b> <br>
                        <div class="px-4 py-2 my-4" v-if="this.question?.questionOptions">
                            <table>
                                <tr>
                                    <th class="table-heading">
                                        Marks
                                    </th>
                                    <th class="table-heading">
                                        Options
                                    </th>
                                </tr>
                                <tr v-for="option in this.question?.questionOptions" :key="option">
                                    <td class="table-data">
                                        {{ option.optionWeightage }}
                                        <span class="mx-2">
                                            <i v-if="option.isChecked && option.optionWeightage > 0"
                                                class="fa-solid fa-check fa-lg" style="color: #2DFF3B;"></i>
                                            <i v-if="option.isChecked && option.optionWeightage <= 0"
                                                class="fa-solid fa-xmark fa-lg" style="color: #FF0000;"></i>
                                        </span>

                                    </td>
                                    <td class="table-data">
                                        {{ option.optionName }}
                                    </td>
                                </tr>
                            </table>

                            <div style="font-weight:600;" class="mt-3" v-if="superadmin()">
                                <span>Marks:</span><span class="mx-2">
                                    <span v-for="score in this.question?.responses" :key="score">
                                        {{ score.marksScored }}
                                    </span>
                                </span>
                            </div>
                        </div>

                        <div v-else>
                            <span class="px-4">No Response</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- client -->
    <div class="accordion-item mt-0" v-if="qType == 1005">
        <h4 class="accordion-header" id="headingOne">
            <button class="accordion-button fw-bolder align-items-sm-start" type="button" data-bs-toggle="collapse"
                aria-expanded="true" aria-controls="Q1" :class="{ collapsed: this.question.show == false }"
                @click=onTabPress(this.question.qid)>
                <span class="me-2">Q.{{ this.index + 1 }}</span>
                <div style="display: flex;flex-wrap: wrap; align-items: flex-start;">
                    <span v-html="this.question?.question"></span>

                    <div v-if="this.question?.mediaAudio" class="mt-1">
                        <audio controls>
                            <source :src="this.question?.mediaAudio" type="audio/mpeg" />
                        </audio>
                    </div>
                    <span v-if="question.responses == null && qType != 1005" class="Unanswered_text">Unanswered</span>
                </div>
            </button>
        </h4>
        <div :class="{ show: this.question.show }" class="accordion-collapse collapse" aria-labelledby="headingOne"
            data-bs-parent="#accordionExample">
            <div class="accordion-body p-0 ">
                <div class="ms-3" v-if="this.question?.imageUrl">
                    <img v-bind:src="this.question?.imageUrl" alt="no image" style="width: 100%; max-width: 720px;">
                </div>
                <!-- <hr class="w-98 my-4 m-auto"> -->
                <SubQuestionType v-for="(subQ, i) in this.question?.dependentQuestions" :subQuestion="subQ" :key="i"
                    :quesType="subQ?.questionType" :pIndex="this.index" :index="i"></SubQuestionType>

            </div>
        </div>
    </div>

    <div class="accordion-item mt-0" v-if="qType == 1037">
        <h4 class="accordion-header" id="headingOne">
            <button class="accordion-button fw-bolder align-items-sm-start" type="button" data-bs-toggle="collapse"
                aria-expanded="true" aria-controls="Q1" :class="{ collapsed: this.question.show == false }"
                @click=onTabPress(this.question.qid)><span class="me-2"></span>
                <div class="row">
                    <div class="col-md-2">Question 1:</div>
                    <div class="col-md-10">
                        <div class="row">
                            <div style="display: flex;flex-wrap: wrap; align-items: flex-start;">

                                <span class="col-12" v-html="this.question.question"></span>
                                <span v-if="question.responses == null && qType != 1005"
                                    class="Unanswered_text">Unanswered</span>
                            </div>
                            <audio class="col-4" controls v-if="this.question?.mediaAudio">
                                <source :src="this.question?.mediaAudio" type="audio/mpeg" />
                            </audio>
                        </div>
                    </div>
                </div>
            </button>
        </h4>
        <div :class="{ show: this.question.show }" class="accordion-collapse collapse" aria-labelledby="headingOne"
            data-bs-parent="#accordionExample">
            <div class="accordion-body p-0">
                <div class="row">
                    <div class="col-md-12">
                        <div class="Report_basic_info_area active-report-repsponses my-4">
                            <div class="table-responsive-sm table-border-M7-responsive mt-3">
                                <table class="table table-border-M7-kj">
                                    <tbody>
                                        <tr>
                                            <td>
                                                <h5 style="font-size: 10px !important ;">Response Confidence</h5>
                                                <P>{{ resp?.scoringResults?.outputConfidence }}</P>
                                            </td>
                                            <td>
                                                <h5 style="font-size: 10px !important ;">Pronunciation(%)</h5>
                                                <P>{{ resp?.scoringResults?.pronunciationAbs }}</P>
                                            </td>
                                            <td>
                                                <h5 style="font-size: 10px !important ;">Fluency(%)</h5>
                                                <P>{{ resp?.scoringResults?.fluencyAbs }}</P>
                                            </td>
                                            <td>
                                                <h5 style="font-size: 10px !important ;">Grammar(%)</h5>
                                                <P>{{ resp?.scoringResults?.grammerAbs }}</P>
                                            </td>
                                            <td>
                                                <h5 style="font-size: 10px !important ;">Comprehension(%)</h5>
                                                <P>{{ resp?.scoringResults?.comprehensionAbs }}</P>
                                            </td>
                                            <td>
                                                <h5 style="font-size: 10px !important ;">Vocabulary(%)</h5>
                                                <P>{{ resp?.scoringResults?.vocabularyAbs }}</P>
                                            </td>
                                            <td>
                                                <h5 style="font-size: 10px !important ;">Transcribe(%)</h5>
                                                <P>{{ resp?.scoringResults?.transcribe }}</P>
                                            </td>

                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>

    </div>

    <div class="accordion-item mt-0" v-if="qType == 1036">
        <h4 class="accordion-header" id="headingOne">
            <button class="accordion-button fw-bolder align-items-sm-start" type="button" data-bs-toggle="collapse"
                aria-expanded="true" aria-controls="Q1" :class="{ collapsed: this.question.show == false }"
                @click="onTabPress(this.question.qid)"><span class="me-2"></span>
                <div class="row">
                    <div class="col-md-2">Question {{ this.index + 1 }}:</div>
                    <div class="col-md-10">
                        <div class="row">
                            <div style="display: flex;flex-wrap: wrap; align-items: flex-start;">

                                <span class="col-12" v-html="this.question.question"></span>
                                <span v-if="question.responses == null && qType != 1005"
                                    class="Unanswered_text">Unanswered</span>
                            </div>
                            <!-- <CustomAudioPlayer  :audioSrc="this.question?.mediaAudio" /> -->
                            <audio class="col-4 my-3" controls v-if="this.question?.mediaAudio">
                                <source :src="this.question?.mediaAudio" type="audio/mpeg" />
                            </audio>
                        </div>
                    </div>
                </div>
            </button>
        </h4>
        <div :class="{ show: this.question.show }" class="accordion-collapse collapse" aria-labelledby="headingOne"
            data-bs-parent="#accordionExample">
            <div class="accordion-body p-0">
                <div class="row">
                    <div class="col-md-12">
                        <div class="Report_basic_info_area active-report-repsponses my-4"
                            v-for="resp in this.question?.responses" :key="resp">
                            <div class="my-3 border-top py-4 mx-4 question-card">
                                <b class="question-heading">Candidate Inputs:</b> <br>
                                <div class="mt-4 mx-4">{{ resp.candidateInputs }}</div>
                            </div>
                            <!-- <div class="table-responsive-sm table-border-M7-responsive mt-3" v-if="superadmin()">
                                <table class="table table-border-M7-kj">
                                    <tbody>
                                        <tr>
                                            <td>
                                                <h5 style="font-size: 10px !important ;">Response Confidence</h5>
                                                <P>{{ resp?.scoringResults?.outputConfidence }}</P>
                                            </td>
                                            <td>
                                                <h5 style="font-size: 10px !important ;">Pronunciation(%)</h5>
                                                <P>{{ resp?.scoringResults?.pronunciationAbs }}</P>
                                            </td>
                                            <td>
                                                <h5 style="font-size: 10px !important ;">Fluency(%)</h5>
                                                <P>{{ resp?.scoringResults?.fluencyAbs }}</P>
                                            </td>
                                            <td>
                                                <h5 style="font-size: 10px !important ;">Grammar(%)</h5>
                                                <P>{{ resp?.scoringResults?.grammerAbs }}</P>
                                            </td>
                                            <td>
                                                <h5 style="font-size: 10px !important ;">Comprehension(%)</h5>
                                                <P>{{ resp?.scoringResults?.comprehensionAbs }}</P>
                                            </td>
                                            <td>
                                                <h5 style="font-size: 10px !important ;">Vocabulary(%)</h5>
                                                <P>{{ resp?.scoringResults?.vocabularyAbs }}</P>
                                            </td>
                                            <td>
                                                <h5 style="font-size: 10px !important ;">Transcribe(%)</h5>
                                                <P>{{ resp?.scoringResults?.transcribe }}</P>
                                            </td>

                                        </tr>
                                    </tbody>
                                </table>
                            </div> -->
                        </div>
                    </div>
                </div>

            </div>
        </div>

    </div>

    <div class="accordion-item mt-0" v-if="qType == 1027">
        <h2 class="accordion-header" id="headingThree">
            <button class="accordion-button fw-bolder align-items-sm-start" type="button" data-bs-toggle="collapse"
                data-bs-target="#Q6" aria-expanded="false" aria-controls="Q6"
                :class="{ collapsed: this.question.show == false }" @click="onTabPress(this.question.qid)">
                <span class="me-2">Q.{{ this.index + 1 }}</span>
                <div style="display: flex;flex-wrap: wrap; align-items: flex-start;">
                    <span v-html="this.question.question"></span>
                    <span v-if="question.responses == null && qType != 1005" class="Unanswered_text">Unanswered

                    </span>
                </div>
            </button>
        </h2>
        <div :class="{ show: this.question.show }" class="accordion-collapse collapse" aria-labelledby="headingThree"
            data-bs-parent="#accordionExample">
            <div class="accordion-body">
                <div class="">
                    <p class="ms-2">
                        <!-- <span v-html="item.question"></span> -->
                    </p>
                    <div class="row">
                        <div class="col-md-4">
                            <button name="cars" class="Report_Responses_Answer_selectBox my-4 form-select"
                                @click="isShow = !isShow">
                                Options Weightage
                            </button>
                        </div>
                    </div>

                    <div class="col-xl-6 col-xl-7 col-md-12" v-show="isShow">
                        <div class="table-border-M7">
                            <div class="row border">
                                <div class="col-md-6 p-0">
                                    <div class="border p-2 bg-secondary-option border-end-0">
                                        Option
                                    </div>
                                    <div v-for="data in questionOptions(true)" :key="data">
                                        <div class="border-top border-bottom p-2"
                                            :class="{ 'Report_Responses_right_option_section border': data.isChecked }">
                                            <span>
                                                {{ data.optionName }}
                                            </span>
                                        </div>
                                    </div>

                                </div>
                                <div class="col-md-6 p-0">
                                    <div class="border p-2 bg-secondary-option border-start-0">
                                        Option
                                    </div>
                                    <div class="" v-for="data in questionOptions(false)" :key="data">
                                        <div class="border-top border-bottom p-2"
                                            :class="{ 'Report_Responses_wrong_option_section border': data.isChecked }">
                                            <span>
                                                {{ data.optionName }}
                                            </span>
                                        </div>
                                    </div>

                                </div>
                            </div>





                        </div>
                    </div>
                </div>
                <hr />
                <div>
                    <p class="fw-bolder">Candidate Input</p>
                </div>
            </div>
        </div>
    </div>

    <div class="accordion-item mt-0" v-if="qType == 1039">
        <h4 class="accordion-header" id="headingOne">
            <button class="accordion-button fw-bolder align-items-sm-start" type="button" data-bs-toggle="collapse"
                aria-expanded="true" aria-controls="Q1" :class="{ collapsed: this.question.show == false }"
                @click=onTabPress(this.question.qid)>
                <span class="me-2">Q.{{ this.index + 1 }}</span>
                <div style="display: flex;flex-wrap: wrap; align-items: flex-start;">
                    <span v-html="this.question?.question"></span>
                    <div v-if="this.question?.mediaAudio" class="mt-1">
                        <audio controls>
                            <source :src="this.question?.mediaAudio" type="audio/mpeg" />
                        </audio>
                    </div>
                    <span v-if="question.responses == null && qType != 1005" class="Unanswered_text">Unanswered</span>
                </div>
            </button>
        </h4>
        <div :class="{ show: this.question.show }" class="accordion-collapse collapse" aria-labelledby="headingOne"
            data-bs-parent="#accordionExample">
            <div class="accordion-body p-0">
                <SubQuestionType v-for="(subQ, i) in this.question?.dependentQuestions" :subQuestion="subQ" :key="i"
                    :quesType="subQ?.questionType" :pIndex="this.index" :index="i"></SubQuestionType>
            </div>
        </div>
    </div>

    <!-- client -->
    <div class="accordion-item mt-0" v-if="qType == 1020">
        <h4 class="accordion-header" id="headingOne">
            <button class="accordion-button fw-bolder align-items-sm-start" type="button" data-bs-toggle="collapse"
                aria-expanded="true" aria-controls="Q1" :class="{ collapsed: this.question.show == false }"
                @click=onTabPress(this.question.qid)>
                <span class="me-2">Q.{{ this.index + 1 }}</span>
                <div style="display: flex;flex-wrap: wrap; align-items: flex-start;">
                    <span v-html="this.question?.question"></span>
                    <span v-if="question.responses == null && qType != 1005" class="Unanswered_text">Unanswered</span>

                </div>
            </button>
        </h4>
        <div :class="{ show: this.question.show }" class="accordion-collapse collapse" aria-labelledby="headingOne"
            data-bs-parent="#accordionExample">
            <div class="accordion-body p-0">
                <div class="row">
                    <div class="col-md-12">
                        <div class="Report_basic_info_area active-report-repsponses my-4"
                            v-for="resp in this.question?.responses" :key="resp">
                            <p class="my-3 border-top p-3">
                                <b>Candidate Input:</b> <br>
                                {{ resp.candidateInputs }}
                            </p>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- client -->
    <div class="accordion-item mt-0" v-if="qType == 1008">
        <h4 class="accordion-header" id="headingOne">
            <button class="accordion-button fw-bolder align-items-sm-start" type="button" data-bs-toggle="collapse"
                aria-expanded="true" aria-controls="Q1" :class="{ collapsed: this.question.show == false }"
                @click=onTabPress(this.question.qid)>
                <span class="me-2">Q.{{ this.index + 1 }}</span>
                <div style="display: flex;flex-wrap: wrap; align-items: flex-start;">
                    <span v-html="this.question?.question"></span>
                    <span v-if="question.responses == null && qType != 1005" class="Unanswered_text">Unanswered</span>
                </div>
            </button>
        </h4>
        <div :class="{ 'show': this.question.show }" class="accordion-collapse collapse" aria-labelledby="headingOne"
            data-bs-parent="#accordionExample">
            <p class="p-3">{{ this.question?.passage }}</p>
            <div class="accordion-body" v-for="sectionRes in this.question.responses" :key="sectionRes">

                <div class="my-3 border-top py-4 mx-2 question-card">
                    <b class="question-heading">Candidate Inputs:</b> <br>
                    <div class="my-4 mx-4">
                        {{ sectionRes.candidateInputs }}
                    </div>

                    <div class="my-3 mx-3" v-if="sectionRes.scoringResults">
                        <table>
                            <tr>
                                <th class="table-heading" v-for="(value, key) in sectionRes.scoringResults" :key="key">
                                    {{ key }}</th>
                            </tr>
                            <tr>
                                <td class="table-data" v-for="(value, key) in sectionRes.scoringResults" :key="key">{{
                                    value }}</td>
                            </tr>
                        </table>
                    </div>

                </div>

            </div>
        </div>
    </div>

    <!-- client -->
    <div class="accordion-item mt-0" v-if="qType == 1044">
        <h4 class="accordion-header" id="headingOne">
            <button class="accordion-button fw-bolder align-items-sm-start" type="button" data-bs-toggle="collapse"
                aria-expanded="true" aria-controls="Q1" :class="{ collapsed: this.question.show == false }"
                @click=onTabPress(this.question.qid)>
                <span class="me-2">Q.{{ this.index + 1 }}</span>
                <div style="display: flex;flex-wrap: wrap; align-items: flex-start;">
                    <span v-html="this.question?.question"></span>
                    <span v-if="question.responses == null" class="Unanswered_text">Unanswered</span>

                </div>
            </button>
        </h4>
        <div :class="{ 'show': this.question.show }" class="accordion-collapse collapse" aria-labelledby="headingOne"
            data-bs-parent="#accordionExample">
            <p class="p-3">{{ this.question?.passage }}</p>

            <div v-if="this.question.questionOptions" class="py-2 px-4">
                <table>
                    <tr>
                        <th class="table-heading">
                            Marks
                        </th>
                        <th class="table-heading">
                            Options
                        </th>
                    </tr>
                    <tr v-for="option in question.questionOptions" :key="option">
                        <td class="table-data">
                            {{ option.optionWeightage }}
                            <span class="mx-2">
                                <i v-if="option.isChecked && option.optionWeightage > 0" class="fa-solid fa-check fa-lg"
                                    style="color: #2DFF3B;"></i>
                                <i v-if="option.isChecked && option.optionWeightage <= 0"
                                    class="fa-solid fa-xmark fa-lg" style="color: #FF0000;"></i>
                            </span>
                        </td>
                        <td class="table-data">
                            {{ option.optionName }}
                        </td>
                    </tr>
                </table>
            </div>
            <div class="accordion-body" v-for="sectionRes in this.question.responses" :key="sectionRes">
                <div class="my-3 border-top py-4 question-card mx-4">
                    <b class="question-heading">Candidate Inputs:</b> <br>
                    <div class="m-4" v-html="sectionRes.candidateInputs"></div>
                </div>

            </div>
        </div>
    </div>

    <div class="accordion-item mt-0" v-if="qType == 1043">
        <h4 class="accordion-header" id="headingOne">
            <button class="accordion-button fw-bolder align-items-sm-start" type="button" data-bs-toggle="collapse"
                aria-expanded="true" aria-controls="Q1" :class="{ collapsed: this.question.show == false }"
                @click=onTabPress(this.question.qid)>
                <span class="me-2">Q.{{ this.index + 1 }}</span>
                <div style="display: flex;flex-wrap: wrap; align-items: flex-start;">
                    <span v-html="this.question?.question"></span>
                    <span v-if="question.responses == null" class="Unanswered_text">Unanswered</span>

                </div>
            </button>
        </h4>
        <div :class="{ 'show': this.question.show }" class="accordion-collapse collapse" aria-labelledby="headingOne"
            data-bs-parent="#accordionExample">
            <p class="p-3" v-if="this.question?.passage">{{ this.question?.passage }}</p>

            <div v-if="this.question.questionOptions" class="py-2 px-4">
                <table>
                    <tr>
                        <th class="table-heading">
                            Marks
                        </th>
                        <th class="table-heading">
                            Options
                        </th>
                    </tr>
                    <tr v-for="option in question.questionOptions" :key="option">
                        <td class="table-data">
                            {{ option.optionWeightage }}
                            <span class="mx-2">
                                <i v-if="option.isChecked && option.optionWeightage > 0" class="fa-solid fa-check fa-lg"
                                    style="color: #2DFF3B;"></i>
                                <i v-if="option.isChecked && option.optionWeightage <= 0"
                                    class="fa-solid fa-xmark fa-lg" style="color: #FF0000;"></i>
                            </span>
                        </td>
                        <td class="table-data">
                            {{ option.optionName }}
                        </td>
                    </tr>
                </table>
            </div>
            <div class="accordion-body" v-for="sectionRes in this.question.responses" :key="sectionRes">
                <div class="my-3 border-top py-4 question-card mx-4">
                    <b class="question-heading">Candidate Inputs:</b> <br>
                    <div class="m-4" v-html="sectionRes.candidateInputs"></div>

                    <div class="remark-card m-4" v-if="sectionRes.scoringResults.remarks">
                        <div class="remark-heading mt-4">
                            AI Remark
                        </div>
                        <div class="m-4">
                            {{ sectionRes.scoringResults.remarks }}
                        </div>


                    </div>
                </div>

            </div>
        </div>
    </div>

</template>
<script>
import SubQuestionType from '../question-type-components/Sub-Question-Type.vue';
import { superadmin } from "../../utils/helper";
// import CustomAudioPlayer from './CustomAudioPlayer.vue';

export default {
    name: "QuestionType",
    props: ["qType", "question", "index", "mainques"],
    components: {
        SubQuestionType,
        // CustomAudioPlayer
    },
    data() {
        return {
            isShow: false,
            questiontype: false,
            questionlist: [],
        };
    },
    methods: {
        superadmin,

        questionOptions(type) {
            if (type == true) {
                var x = this.question?.questionOptions.filter((x) => x.optionWeightage > 0)
                return x;
                //    console.log(x);
            } else {
                var y = this.question?.questionOptions.filter((x) => x.optionWeightage <= 0);
                return y;
                // console.log(y);
            }

        },
        onTabPress(id) {
            this.mainques?.questions.forEach((elm) => {
                if (elm.qid == id && elm.show != true) elm.show = true;

                else elm.show = false;
            })
        },
    }
};
</script>
<style>
.bg-secondary-option {
    background: #d2d2d2;
}

.table-heading {
    padding: 10px;
    background-color: #FFF;
    box-shadow: 0px 0px 10px 0px #66666640;
    border: 5px solid #f1f1f1;
    font-weight: 600;

}

.table-data {
    padding: 10px;
    background-color: #FFF;
    border: 4px solid #222222;
    box-shadow: 0px 0px 10px 0px #66666640;
    font-weight: 600;
}

.question-card {
    border-radius: 24px;
    border: 2px solid rgba(75, 46, 238, 0.10);
    background: #F8F7FF;
}


.question-heading {
    font-size: large;
    color: #7B68EE;
    width: max-content;
    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: 30px;
    padding-right: 15px;
    border-radius: 0px 18px 18px 0px;
    background: rgba(75, 46, 238, 0.10);
    font-weight: 600;
}

.remark-card {
    border-radius: 24px;
    border: 2px solid #FFD87D;
    background: #FFECA6;
}


.remark-heading {
    font-size: large;
    color: #FF9225;
    width: max-content;
    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: 30px;
    padding-right: 15px;
    border-radius: 0px 18px 18px 0px;
    background: #FFD87D;
    font-weight: 600;
}
</style>